import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-edit-product-smart',
  template: '<app-edit-product [productDetails]="productDetails" [producttypes]="producttypes" [plantypes]="plantypes" [providerService]="providerService"  [transactionTypes]="transactionTypes" [codeGroups]="codeGroups" [carrierTypes]="carrierTypes" [serviceCountries]="serviceCountries" [responseTypes]="responseTypes"  [allProviders]="allProviders"></app-edit-product>',
  styles: [
  ]
})
export class EditProductSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  // providers: any;
  producttypes: any;
  plantypes: any;
  providerService: any;
  transactionTypes: any;
  codeGroups: any;
  carrierTypes: any;
  productDetails: [];
  serviceCountries: any;
  responseTypes: any;
  productId: number;
  allProviders: any;

  constructor(private productService: ProductService, private activeRoute: ActivatedRoute) {
    super();
    this.getAllProductServiceData();
  }

  getAllProductServiceData() {
    this.productId = this.activeRoute.snapshot.params.id;
    let productDetails = this.productService.getProductDetails(this.productId);
    let allproducttypes = this.productService.getallproducttypes();
    let planTypes = this.productService.getallplantypes();
    let providerService = this.productService.getallProviderService();
    let responseTypes = this.productService.getallresponseTypes();
    let transactionTypes = this.productService.getTransactionTypes();
    let codeGroups = this.productService.getcodeGroups();
    let carrierTypes = this.productService.getCarriers();
    let allProviders = this.productService.getactiveproviders()
    let serviceCountries = this.productService.getserviceCountry();

    forkJoin([productDetails, allproducttypes, planTypes, providerService, responseTypes, transactionTypes, codeGroups, carrierTypes, allProviders, serviceCountries]).subscribe(
      res => {
        this.productDetails = res[0].data;
        this.producttypes = res[1].data;
        this.plantypes = res[2].data;
        this.providerService = res[3].data;
        this.responseTypes = res[4].data;
        this.transactionTypes = res[5].data;
        this.codeGroups = res[6].data;
        this.carrierTypes = res[7].data;
        this.allProviders = res[8].data
        this.serviceCountries = res[9].data;
      }
    );
  }


  ngOnInit(): void {
    super.ngOnInit();

  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
